import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const MOOD_CLASSES = [
  "Excitement & Passion",
  "Happiness & Peacefulness",
  "Sadness & Despair",
  "Amusement",
  "Anger & Fear",
];

const MOOD_COLORS = {
  "Excitement & Passion": "#ff9800",
  "Happiness & Peacefulness": "#4caf50",
  "Sadness & Despair": "#2196f3",
  Amusement: "#f44336",
  "Anger & Fear": "#9c27b0",
};

const MoodResults = ({ predictions }) => {
  const moodData = MOOD_CLASSES.map((mood, index) => ({
    mood,
    percentage: Math.round(predictions[index] * 100),
  }));

  return (
    <div className="w-full h-full flex flex-col items-center justify-between p-4 bg-gray-100 font-sans">
      <h1 className="text-3xl font-extrabold text-center text-gray-800 tracking-wide mb-4">
        Mood Analysis Results
      </h1>
      <div className="w-full h-full flex items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={moodData}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <XAxis type="number" hide />
            <YAxis
              dataKey="mood"
              type="category"
              width={150}
              tick={{ fill: "#4a5568", fontSize: 14, fontWeight: 700 }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                fontSize: "14px",
                fontWeight: 500,
              }}
            />
            <Bar dataKey="percentage" isAnimationActive={false}>
              {moodData.map(({ mood }) => (
                <Cell key={mood} fill={MOOD_COLORS[mood]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MoodResults;
